<template>
    <div>
        <el-card class="allot_card">
            <div slot="header" class="clearfix">
                <span style="line-height: 36px;">设备公众号列表</span>
                <el-button style="float: right;" type="danger" @click="deletleItem">删除</el-button>
            </div>
            <div>
                <el-table
                ref="itemSelect"
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="itemData"
                stripe
                border
                fit
                height="600"
                style="width: 100%"
                @selection-change="itemSelectionChange">
                    <el-table-column
                        type="selection"
                        width="40">
                    </el-table-column>
                    <el-table-column
                        prop="id"
                        header-align="center"
                        width="80"
                        label="ID">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        header-align="center"
                        min-width="95"
                        label="名称">
                    </el-table-column>
                    <el-table-column
                        prop="desc"
                        header-align="center"
                        min-width="95"
                        label="描述">
                    </el-table-column>
                    <el-table-column
                        prop="appid"
                        header-align="center"
                        min-width="95"
                        label="appId">
                    </el-table-column>
                    <el-table-column
                        prop="logo"
                        header-align="center"
                        width="150"
                        label="logo">
                        <template scope="scope">
                            <a style="barder: 1px solid #ddd" :href="scope.row.logo" target="_blank">
                                <img style="width:100%; max-width:150px; margin-top:10px;" v-bind:src="scope.row.logo" />
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="qrcode"
                        header-align="center"
                        width="150"
                        label="二维码">
                        <template scope="scope">
                            <a style="barder: 1px solid #ddd" :href="scope.row.qrcode" target="_blank">
                                <img style="width:100%; max-width:150px; margin-top:10px;" v-bind:src="scope.row.qrcode" />
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="url"
                        header-align="center"
                        min-width="200"
                        label="url">
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        header-align="center"
                        width="105"
                        label="状态">
                    </el-table-column>
                    <el-table-column
                        prop="range"
                        header-align="center"
                        width="105"
                        label="范围">
                    </el-table-column>
                </el-table>
                <div class="table_pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNo"
                        :page-sizes="[5, 10, 15, 20]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageTotal">
                    </el-pagination>
                </div>
            </div>
        </el-card>
        <div class="seeWxMask" v-if="deleleShowBox">
            <div class="box">
                <h3>提示</h3>
                <div class="content">
                    <p>此操作将在设备上删除所选中的文件, 是否继续?</p>
                    <div>
                        <el-button @click="boxClose">取消</el-button>
                        <el-button @click="delItemCommit" type="primary">确认</el-button>
                    </div>
                </div>
                <span @click="boxClose"
                style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949">
                    <i class="el-icon-close Danger"></i>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import $axios from '../../https/config'
    export default {
      props: ['deviceCode'],
      data () {
        return {
          itemData: [],
          itemSelect: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          table_loading: false,
          adResSelectList: [],
          deleleShowBox: false,
          delFinish: false
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryItemDataList(this.pageNo, this.pageSize, this.deviceCode)
      },
      methods: {
        queryItemDataList (tPageNo, tPageSize, tDevieCode) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            deviceCode: tDevieCode
          }
          this.table_loading = true
          $axios.get('/third/getDeviceWeixin', params, 'headers', function (res) {
            _this.table_loading = false
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    id: itemData.id,
                    name: itemData.name,
                    desc: itemData.description,
                    appid: itemData.appid,
                    logo: itemData.wx_logo,
                    qrcode: itemData.qrcode,
                    url: itemData.wxArticleUrl,
                    status: itemData.status,
                    range: itemData.global
                  }
                  resData.push(item)
                }
                _this.itemData = resData
              }
            } else {
            }
          }, function (err) {
            err
          })
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryItemDataList(this.pageNo, this.pageSize, this.deviceCode)
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryItemDataList(this.pageNo, this.pageSize, this.deviceCode)
        },
        itemSelectionChange (val) {
          this.itemSelect = val
        },
        deletleItem () {
          if (this.itemSelect.length > 0) {
            this.deleleShowBox = true
          } else {
            this.$message({
              type: 'warning',
              duration: 1000 * 5,
              message: '请选择要删除的广告!'
            })
          }
        },
        delItemCommit () {
          for (var i = 0; i < this.itemSelect.length; i++) {
            if (this.itemSelect.length - 1 === i) {
              this.delFinish = true
            } else {
              this.delFinish = false
            }
            // console.log('id=' + JSON.stringify(this.itemSelect[i]))
            this.delSetAdResource(this.itemSelect[i].id, this.deviceCode)
          }
        },
        refrushAdResource (tDeviceCode) {
          var _this = this
          var params = {
            deviceCode: '' + tDeviceCode
          }
          $axios.get('/third/getDeviceWeixin', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              if (_this.delFinish) {
                _this.boxClose(true)
              }
              console.log('111')
              _this.$message({
                type: 'success',
                duration: 1000 * 5,
                message: '删除广告成功!'
              })
            } else {
              if (_this.delFinish) {
                _this.boxClose(true)
              }
              _this.$message({
                type: 'error',
                duration: 1000 * 5,
                message: '删除广告失败!'
              })
            }
          }, function (err) {
            err
          })
        },
        delSetAdResource (tItemSelect, tDeviceCode) {
          var _this = this
          var mDeviceList = []
          var mWxList = []
          mDeviceList.push({
            deviceCode: tDeviceCode
          })
          mWxList.push({
            id: tItemSelect + ''
          })
          var params = {
            deviceList: mDeviceList,
            wxList: mWxList
          }
          $axios.post('/device/delDeviceWx', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              if (_this.delFinish) {
                _this.boxClose(true)
              }
              this.refrushAdResource(tItemSelect, tDeviceCode)
              _this.$message({
                type: 'success',
                message: '删除广告成功!'
              })
            } else {
              if (_this.delFinish) {
                // _this.boxClose(true)
              }
              _this.$message({
                type: 'error',
                duration: 1000 * 5,
                message: '删除广告失败!'
              })
            }
          }, function (err) {
            err
          })
        },
        boxClose (tType) {
          this.deleleShowBox = false
          if (tType) {
            this.$emit('boxClose', tType)
          }
        }
      }
    }
</script>

<style lang="scss">
    .allot_card {
        margin: 10px;
        position: relative;
        overflow-y: auto;
        height: 85%;

        .el-card__header {
            padding: 10px;
        }
        .el-card__body {
            padding: 10px;
        }
    }
    .seeWxMask {
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        position: fixed;
        background: rgba(0, 0, 0, 0.3);
        z-index: 1001;

        .box {
            width: 400px;
            background: white;
            border-radius: 5px;
            box-shadow: 0 0 10px #666;
            top: 30%;
            left: 50%;
            margin-left: -200px;
            position: absolute;

            .el-button {
                width: 40%;
                margin: 4%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/deviceMgr/seeWeixin.vue